const messages: any = {}

export default messages
